import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, messageErreur } from "@/lib/api";

export const MOTIFS = ["Non éligible", "Client pas au courant", "Doublon", "Faux numéro", "Autre"];
const slug = (t) => t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function AnnulerDialog({ ouvert, setOuvert, ficheId, onFait }) {
  const [motif, setMotif] = useState("");
  const [precision, setPrecision] = useState("");
  const envoyer = () => api.post(`/confirmation/${ficheId}/annuler`, { motif, precision }).then(() => { toast.success("Dossier annulé, l'agent est prévenu."); setOuvert(false); onFait(); })
    .catch((e) => toast.error(messageErreur(e)));
  return (
    <Dialog open={ouvert} onOpenChange={setOuvert}>
      <DialogContent className="at-popover max-w-md [&>button]:min-h-[44px] [&>button]:min-w-[44px] [&>button]:flex [&>button]:items-center [&>button]:justify-center" data-testid="cancel-dialog">
        <DialogHeader><DialogTitle>Annuler le dossier</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {MOTIFS.map((m) => (
            <button key={m} type="button" onClick={() => setMotif(m)} className="at-btn !min-h-[46px] !px-2 text-sm" style={{ background: motif === m ? "var(--accent)" : "var(--surface-2)", color: motif === m ? "var(--accent-ink)" : "var(--ink)" }} data-testid={`cancel-reason-${slug(m)}`}>{m}</button>
          ))}
        </div>
        <textarea value={precision} onChange={(e) => setPrecision(e.target.value)} rows={2} maxLength={200} placeholder={motif === "Autre" ? "Précisez le motif (obligatoire)" : "Précision (facultatif)"} className="at-input !h-auto py-2" data-testid="cancel-precision" />
        <button type="button" disabled={!motif || (motif === "Autre" && !precision.trim())} onClick={envoyer} className="at-btn at-btn-danger w-full !min-h-[46px]" data-testid="cancel-confirm">Annuler le dossier</button>
      </DialogContent>
    </Dialog>
  );
}
